import { apiClient } from '../../../platform/api/apiClient';

export const scoringService = {
    getScoreSheet(scoreSheetId) {
        return apiClient.get(`scoresheet/${scoreSheetId}`);
    },

    getScoreSheetResults(scoreSheetId) {
        return apiClient.get(`scoresheet/${scoreSheetId}/results`);
    },

    finishScoreSheet(scoreSheetId) {
        return apiClient.post(`scoresheet/${scoreSheetId}/finish`);
    },

    getEventScoreSheets(eventId) {
        return apiClient.get(`scoresheet/event/${eventId}`);
    },

    createScoreSheet(payload) {
        return apiClient.post('scoresheet', { json: payload });
    },

    updateRound(scoreSheetId, roundId, payload) {
        return apiClient.put(`scoresheet/${scoreSheetId}/rounds/${roundId}`, { json: payload });
    },

    recordFlexibleShot(scoreSheetId, payload) {
        return apiClient.post(`scoresheet/${scoreSheetId}/flexible-shot`, { json: payload });
    },

    deleteScoreSheet(scoreSheetId) {
        return apiClient.del(`scoresheet/${scoreSheetId}`);
    }
};
